import { ConfigService, SystemUrlService } from "@xo/client-common";

export class Type3NumberUrlService extends SystemUrlService {
    constructor(system: string, configService: ConfigService) {
        super(system, "SpecApp", "Type3Number", configService);
    }
}
